import "./style/BottomPanel.scss"
import { FaGift, FaChartPie } from "react-icons/fa"

const BottomPanel = () => {
  return (
    <div className="bottom-panel">
      <div className="claim-card">
        <div className="icon">
          <FaGift />
        </div>
        <div className="details">
          <h3>Claim Your Bonus</h3>
          <p>You’re eligible for a loyalty bonus. Don’t miss it!</p>
        </div>
        <button>Claim Now</button>
      </div>

      <div className="promo-card">
        <div className="icon">
          <FaChartPie />
        </div>
        <div className="details">
          <h3>Portfolio Allocation</h3>
          <p>Get insights into your crypto asset distribution.</p>
        </div>
        <button>View</button>
      </div>
    </div>
  )
}

export default BottomPanel
